import { atom } from 'jotai'
import { ICommonCountry } from '../types'

type ICountryOptionsState = Array<ICommonCountry> | null

const defaultState: ICountryOptionsState = null

// base atom with initial value
export const countryOptionsAtom = atom<ICountryOptionsState>(defaultState)